import React, { createContext, useContext, useState } from "react";

const TableTypeContext = createContext()

export const TableTypeProvider = ({ children }) => {
  const [currentTableType, setCurrentTableType] = useState('default');

  return (
    <TableTypeContext.Provider value={{ currentTableType,setCurrentTableType }}>
      {children}
    </TableTypeContext.Provider>
  );
};

export const useTableType = () => useContext(TableTypeContext);